module.exports = {"510812100":"朝天镇","510812101":"大滩镇","510812102":"羊木镇","510812103":"曾家镇","510812104":"中子镇","510812105":"沙河镇","510812109":"两河口镇","510812110":"云雾山镇","510812111":"水磨沟镇","510812112":"李家镇","510812214":"麻柳乡","510812215":"临溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510812.json
// module id = 2442
// module chunks = 0